import React, { FunctionComponent } from 'react';
import Translate from 'ui/atoms/translate';
import Spacer from 'ui/atoms/spacer';
import { useTranslateWithStringArgs } from 'ui/hooks/use-translate';
import Select from 'ui/atoms/select';
import FormGroup from 'src/ui/molecules/form-group';

export interface FileToUpload {
  file: File | null;
  documentType?: string;
}

export const FileUploadDocumentType: FunctionComponent<{
  uploadedFile: FileToUpload;
  documentTypes?: Array<any>;
  showValidatedForm?: boolean;
  onSelectDocumentType?: (documentType: string, fileName?: string) => void;
}> = ({ uploadedFile, documentTypes, showValidatedForm, onSelectDocumentType }) => {
  const translate = useTranslateWithStringArgs();

  if (!documentTypes?.length) return <></>;

  return (
    <>
      <Spacer y={2} />
      <FormGroup
        error={
          !uploadedFile?.documentType && showValidatedForm ? (
            <Translate name="form.errors.required.documentType" />
          ) : null
        }
      >
        <Select
          required={true}
          valid={!!uploadedFile?.documentType || !showValidatedForm}
          label={translate('addInvestment.documentType')}
          options={documentTypes.map((documentType) => ({
            value: documentType.value || documentType.label,
            label: documentType.label || documentType.value,
          }))}
          value={uploadedFile.documentType}
          onChange={(evt) => {
            onSelectDocumentType && onSelectDocumentType(evt, uploadedFile?.file?.name);
          }}
        />
      </FormGroup>
    </>
  );
};

export default FileUploadDocumentType;
